import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=62c70afb&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"
import style0 from "./Video.vue?vue&type=style&index=0&id=62c70afb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c70afb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('/vercel/path0/components/elements/Video.vue').default,SanityFile: require('/vercel/path0/node_modules/@nuxtjs/sanity/dist/components/sanity-file.js').default})
